import { FC, forwardRef, useRef } from 'react'
import { IconAlert, PopoverV2, WithOutsideTracking } from '@opallabs/kuiper'
import { Button } from '@opallabs/lapidary'

type PopoverContentProps = {
  onExportPopoverConfirm: () => void
}

const PopoverContent = forwardRef<HTMLDivElement, PopoverContentProps>(
  function CSVExportPopoverContent({ onExportPopoverConfirm }, ref) {
    return (
      <IconAlert
        icon="csv-export-illo"
        className="alert-notice"
        title="We're building your export!"
        message="When it's finished, you'll receive a link to download."
        ref={ref}
      >
        <Button
          buttonText="Got It"
          name="confirm"
          variant="primary"
          onClick={onExportPopoverConfirm}
        />
      </IconAlert>
    )
  }
)

export const CSVExportPopover: FC<
  React.PropsWithChildren<PopoverContentProps>
> = ({ onExportPopoverConfirm, children }) => {
  const alertRef = useRef<HTMLDivElement>(null)

  return (
    <WithOutsideTracking
      onOutsideClick={() => onExportPopoverConfirm()}
      getTrackingContext={() => alertRef.current}
    >
      <PopoverV2
        content={
          <PopoverContent
            onExportPopoverConfirm={onExportPopoverConfirm}
            ref={alertRef}
          />
        }
        open={true}
        onClose={onExportPopoverConfirm}
        themeClass="white"
        trigger={children}
      />
    </WithOutsideTracking>
  )
}
